import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["mainDashboard", "save", "view", "content", "4444", "5555", "6666", "7777", "8888", "9999"]

  connect() {
    this.controllerName = `operations--products--clinics--clients--receivables--add--dashboard`
    this.setAccountPermission()
  }

  doReceivablesDashboard() {
    var html = `<div class="row" data-${this.controllerName}-target="mainDashboard">
                  <div class="col-12 px-0" data-${this.controllerName}-target="content" data-controller="operations--products--clinics--clients--receivables--add--show
                                                                                                         operations--products--clinics--clients--receivables--add--save"></div>
                </div>`

    var controller = this
    new Promise(function (resolve) {
      resolve(controller.getControllerByIdentifier(`operations--products--clinics--clients--show--main`).contentTarget.innerHTML = html)
    }).then(() => {
      controller.getControllerByIdentifier(`operations--products--clinics--clients--show--submenu`).dashboardToggleBtn(`NOTA FISCAL`)

      controller.getControllerByIdentifier(`operations--products--clinics--clients--receivables--add--save`).permission = this.permission
      controller.getControllerByIdentifier(`operations--products--clinics--clients--receivables--add--save`).taker_permission = this.taker_permission
      controller.getControllerByIdentifier(`operations--products--clinics--clients--receivables--add--show`).permission = this.permission
      controller.getControllerByIdentifier(`operations--products--clinics--clients--receivables--add--show`).integration_permission = this.integration_permission
    })
  }

  emitReceivable() {
    this.doReceivablesDashboard()
  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }

  nameTarget(target) {
    return this.targets.find(target)
  }

  setAccountPermission() {
    if (this.application.current_user.account_kind == `admin` || this.application.current_user.account_kind == `team`) {
      this.permission = `medclinic_client_receivables`
      this.taker_permission = `medclinic_client_takers`
      this.integration_permission = `medclinic_client_integration_invoices`
    } else if (this.application.current_user.account_kind == `doctor`) {
      this.permission = `medclinic_doctor_client_receivables`
      this.taker_permission = `medclinic_doctor_client_takers`
      this.integration_permission = `medclinic_doctor_client_integration_invoices`
    } else if (this.application.current_user.account_kind == `helper`) {
      this.permission = `medclinic_helper_client_receivables`
      this.taker_permission = `medclinic_helper_client_takers`
      this.integration_permission = `medclinic_helper_client_integration_invoices`
    }
  }

  // new Promise(function (resolve) {
  //   resolve()
  // }).then(() => {
  // }) 

}
